import React from 'react'
import classNames from 'classnames'

import { Icon } from '@scentregroup/ui'

import style from './index.scss'

type Props = {
  className?: string
}

const Search: React.FC<Props> = ({ className }) => (
  <div className={classNames(className, style.search)}>
    <Icon size="medium" type="search" className={classNames(style.icon)} />
    <input placeholder="What are you looking for?" />
  </div>
)

export default Search
